import { CommonModule } from '@angular/common';
import { Component, Inject, OnDestroy } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { ToastrService } from 'ngx-toastr';
import { MaterialModule } from 'src/app/material.module';
import { BillChargeService } from '../bill-charge.service';
import { Subject } from 'rxjs';
import { BillCharge } from '../ibill-charge';
import { TranslationUtils } from 'src/app/common/utils/translation.utils';
import { InsuranceChargeCategory, InsuranceChargeCategoryLabels } from 'src/app/common/enums/insuranceChargeCategory';

@Component({
  selector: 'app-bill-charge-detail',
  standalone: true,
  imports: [
    CommonModule,
    MaterialModule,
    TablerIconsModule,
    ReactiveFormsModule,
    TranslateModule
  ],
  templateUrl: './bill-charge-detail.component.html',
  styleUrl: './bill-charge-detail.component.scss'
})
export class BillChargeDetailComponent implements OnDestroy {
  billChargeForm: FormGroup;
  isEdit: boolean;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  InsuranceChargeCategoryList = Object.values(InsuranceChargeCategory).filter(x => typeof x === 'number');
  InsuranceChargeCategoryData = InsuranceChargeCategoryLabels;
  isIPD: boolean = false;

  constructor(
    private _formbuilder: FormBuilder,
    private toastr: ToastrService,
    private _billChargeService: BillChargeService,
    private dialogRef: MatDialogRef<BillChargeDetailComponent>,
    private translate: TranslateService,
    private translationUtils: TranslationUtils,
    @Inject(MAT_DIALOG_DATA) private _data: { BillChargeDetails: BillCharge, isEdit: boolean, isDisabled: boolean },
    @Inject(MAT_DIALOG_DATA) public data: { name: string }//From bill recipt
  ) {
    this.isEdit = _data?.isEdit;
  }

  ngOnInit(): void {
    this.isIPD = this._billChargeService.isIPDTabShown();
    const formattedCharge = this._data?.BillChargeDetails?.charge ? parseFloat(this._data?.BillChargeDetails?.charge).toFixed(2) : '';
    this.billChargeForm = this._formbuilder.group({
      name: [this._data?.BillChargeDetails?.name || this.data?.name, [Validators.required, Validators.maxLength(50)]],
      charge: [formattedCharge, [Validators.required, Validators.pattern(/^\d+(\.\d{1,2})?$/), Validators.maxLength(10)]],
      insuranceChargeCategoryId: [InsuranceChargeCategory[this._data?.BillChargeDetails?.insuranceChargeCategoryId] || null],
      isDefault: [this._data?.BillChargeDetails?.isDefault || false]
    })
    if (this._data?.isDisabled) {
      this.billChargeForm.get('name')?.disable();
    }
  }


  onSaveBillCharge() {
    const data = this.billChargeForm.getRawValue();
    this._billChargeService.createBillCharge(data).subscribe((response) => {
      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.CREATE', this.translate.instant('ENTITY.BILL_CHARGE')));
      }
      else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));

      }
    });
  }

  onUpdateBillCharge() {
    const data = {
      id: this._data?.BillChargeDetails?.id,
      ...this.billChargeForm.getRawValue()
    };
    this._billChargeService.updateBillCharge(data).subscribe((response) => {

      if (response.isSuccess) {
        this.dialogRef.close(response);
        this.toastr.success(this.translationUtils.getTranslatedMessage('COMMON.UPDATE', this.translate.instant('ENTITY.BILL_CHARGE')));
      } else {
        const allErrors = Object.values(response.errors).flat();
        this.toastr.error(allErrors.join("\n"));

      }
    });
  }

  OnCloseDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

}
